module.exports = __webpack_public_path__ + "static/media/bronchioles.a25e53b3.ogg";